// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';

// Project imports

import Modal from '../../../components/Modal';
import LoadMask from '../../../components/LoadMask';
import { updatePassword } from '../../../redux/auth';
import { getUpdatePasswordUI } from '../../../redux/selectors';

// Module imports

import ChangePasswordForm from './ChangePasswordForm';

// Component

class UpdatePasswordModal extends Component {
  _submit = ({ currentPassword, newPassword }) => {
    this.props.dispatch(updatePassword(currentPassword, newPassword)).then(
      () => {
        this.setState({ showSuccessMessage: true });

        this.props.onUpdateSuccess();
      },
      // error
      () => { },
    );
  }

  _renderContent = () => {
    const { ui } = this.props;

    return (
      <div>
        <p>Visando sua segurança, pedimos para que você altere a senha que recebeu por e-mail para uma senha de sua preferência antes de começar a utilizar a plataforma.</p>
        <ChangePasswordForm
          ui={ui}
          onSubmit={this._submit}
        />
      </div>
    );
  }

  render() {
    const { ui, firstAccess } = this.props;

    if (!firstAccess) {
      return null;
    }

    return (
      <Modal
        title="Bem vindo à Plataforma LUFT Digital"
        size="small"
        onBackdropClick={this._dismiss}
      >
        {this._renderContent()}
        {
          ui.isFetching &&
          <LoadMask text="Alterando..." />
        }
      </Modal>
    );
  }
}

// Redux

function mapStateToProps(state) {
  return {
    ui: getUpdatePasswordUI(state),
    firstAccess: state.auth.firstAccess,
  };
}

export default connect(mapStateToProps)(UpdatePasswordModal);
